import React from 'react'
import * as yup from 'yup'

import { FormattedMessage } from '@divvy-web/i18n'

import { phoneNumber } from '@sputnik/schema/creditApplication/person'

export const enterPhoneNumberModalValidationSchema = yup.object().shape({
  personId: yup.string().required(),
  smsConsentGiven: yup.boolean().required(),
  phoneNumber: phoneNumber.required(() => (
    <FormattedMessage
      defaultMessage='Phone number is required'
      id='sputnik.enterPhoneNumberModalValidationSchema__UHu1T/'
    />
  )),
})

export type EnterPhoneNumberModalValidationSchema = yup.InferType<typeof enterPhoneNumberModalValidationSchema>
